/**
 * `rel` for store website links — mirrors admin `linkRelType` on Store.
 * Always opens in a new tab; `noopener` avoids tab-nabbing.
 */
export function relFromStoreLinkPolicy(linkRelType) {
  switch (linkRelType) {
    case "follow":
      return "noopener";
    case "nofollow":
      return "nofollow noopener noreferrer";
    case "sponsored":
      return "sponsored noopener noreferrer";
    case "noreferrer":
    default:
      return "noreferrer noopener";
  }
}
